var React = require('react');

function MobileF (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22,2H10A3.00879,3.00879,0,0,0,7,5V27a3.00883,3.00883,0,0,0,3,3H22a3.00883,3.00883,0,0,0,3-3V5A3.00879,3.00879,0,0,0,22,2Zm1,25a1.003,1.003,0,0,1-1,1H10a1.003,1.003,0,0,1-1-1V26H23ZM23,6H9V5a1.003,1.003,0,0,1,1-1H22a1.003,1.003,0,0,1,1,1Z"}));
}

MobileF.defaultProps = {"viewBox":"0 0 32 32","id":"ki-mobile-f"};

module.exports = MobileF;

MobileF.default = MobileF;
